<template>
  <!-- <div id="app" class="noselect" v-bind:style="backgroundStyle"> -->
  <div id="app" class="noselect">
    <img class="rotateImg" src="static/images/rotateDeviceImg.png" alt="rotate device image">
    <WelcomePage v-if="showWelcome" />
    <Question :active="activateQuestion" v-if="!quizComplete" />
    <MenuUnlock :selectedOption="selectedOption" v-if="showMenu"/>
    <BackgroundHolder v-if="showBackground" />

    <div class="spinner-area tally" v-if="calculatingResults">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <!-- <audio loop id="audioBells" ref="audioBells" src="static/audio/bells-16db-peaks.mp3"></audio> -->
  </div>
</template>

<script>
/* eslint-disable */
//import HelloWorld from './components/HelloWorld'
import WelcomePage from './components/WelcomePage';
import Question from './components/Question';
import MenuUnlock from './components/MenuUnlock';
import BackgroundHolder from './components/BackgroundHolder';
import { eventBus } from './EventBus';

export default {
  created() {
    eventBus.$on('beginQuizQuestions', () => {
      this.showWelcome = false;
      this.showBackground = true;
      this.activateQuestion = true;
      //this.dateSwap();
      //this.playAudio();
    });

     eventBus.$on('WelcomeQuiz', () => {
      this.showWelcome = true;
      this.activateQuestion = false;
      //this.playAudio();
    });

     eventBus.$on('UnlockMenu', () => {
       this.activateQuestion = false;
      this.showMenu = true;
      //this.playAudio();
    });

    window.addEventListener('orientationchange', this.handleOrientationChange);
    //this.dateSwap();
  },
  destroyed() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
  },

  mounted() {
    // Use if need to skip welcome page and go straight to the questions
    eventBus.WelcomeQuiz();
  },
  name: 'App',
  data() {
    return {
      selectedOption: '',
      showBackground: false,
      showWelcome: true,
      showMenu: false,
      activateQuestion: false,
      quizComplete: false,
      quizResultObject: null,
      calculatingResults: false,
      isLandscape: false,
      currentQuestion: 0,
      dateCheck: 'pre'
    };
  },
  components: {
    WelcomePage,
    Question,
    MenuUnlock,
    BackgroundHolder
  },
};
</script>

<style lang="scss">
/* importing boostrap's reset CSS only */

@import 'assets/bootstrap-reboot.css';
/* importing animate CSS */

@import 'assets/animate.css';

.rotateImg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: black;
  object-fit: contain;
  transform: scale(3, 3);

  @media screen and (orientation: portrait) {
    display: none;
  }

  @media screen and (orientation: landscape) {
    display: block;
  }
}

.spinner-area.tally {
  bottom: 0;
  top: 60px;

  .spinner > div {
    // background-color: #0e2e6b;
    background-color: #ffffff;
  }
}

body {
  // background-color: #0e2e6b;
  background-color: #ffffff;
}

body,
html {
  margin: 0;
  height: 100%;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
  supported by Chrome and Opera */
}

// Laptops and Desktops don't get a full-screen quiz, but shouldn't be able to see it to begin with...
@media all and (min-device-width: 1024px) {
  /* This media query is sort of temp for testing */
  body {
    background-color: #fff;
    width: 375px;
    height: 667px; // width: 100%;
    // height: 100%;
    margin: auto;
    background-size: contain;
  }

  #app {
    overflow: hidden;
  }
}

@font-face {
  font-family: 'SoDoSans-Bold';
  src: url('./assets/fonts/SoDoSans-Bold.woff') format('woff');
}

#app {
  font-family: 'SoDoSans-Bold';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  height: 100%;
  position: relative;

  /*background-image: url("./assets/background.jpg");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  overflow: hidden;
}

@media all and (min-width: 768px) {
  #app {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue